import { defineStore } from "pinia";

export const useNavStore = defineStore("nav", {
    state: () => ({
        nav: {},
        firstLevel: [],
        secondLevel: [],
        secondLevelMob: [],
        thirdLevel: [],
        activePathName: null,
    }),
    getters: {
        getAllDirections() {
            return this.nav["all-directions"];
        },
        getMainNav() {
            return this.nav.main.sections;
        },
        getInnerNav() {
            return this.nav.inner.sections;
        },
        getFirstLevel() {
            return this.firstLevel;
        },
        getSecondLevel() {
            return this.secondLevel;
        },
        getSecondLevelMob() {
            return this.secondLevelMob;
        },
        getThirdLevel() {
            return this.thirdLevel;
        },
    },
    actions: {
        getNavList() {
            let navList = document.getElementById("header-menu");
            this.nav = JSON.parse(navList.getAttribute("data"));
            this.firstLevel = [
                ...this.nav.main.sections,
                ...this.nav.inner.sections,
            ];
            this.firstLevel.forEach((el, idx) => {
                if (el?.selected === "Y" && el.sections) {
                    this.secondLevel = Array.from(el.sections);
                    this.secondLevelMob = Array.from(el.sections);
                } else if (el?.sections) {
                    el.sections.forEach((el) => {
                        if (el?.selected === "Y" && el.sections) {
                            this.secondLevel = Array.from(
                                this.firstLevel[idx].sections
                            );
                            this.secondLevelMob = Array.from(
                                this.firstLevel[idx].sections
                            );
                        }
                    });
                }
            });
            this.activePathName =
                window.location.pathname + window.location.hash;
        },

        fillSecondLevelMob(item, id) {
            this.secondLevelMob = [];
            this.firstLevel.forEach((el, idx) => {
                if (el.name === item.name && el.sections) {
                    this.secondLevelMob = Array.from(el.sections);
                } else if (el?.sections) {
                    el.sections.forEach((el) => {
                        if (el?.selected === "Y" && el.sections) {
                            this.secondLevelMob = Array.from(
                                this.firstLevel[id].sections
                            );
                        }
                    });
                }
            });
        },

        activeThirdLevel(item) {
            this.thirdLevel = null;
            this.thirdLevel = this.secondLevel.find(
                (el) => el.name === item.name
            ).sections;
            this.showThird = true;
        },
        activeThirdLevelMob(item) {
            this.thirdLevel = null;
            this.thirdLevel = this.secondLevelMob.find(
                (el) => el.name === item.name
            )?.sections;
        },
        setNewPathName(path) {
            this.activePathName = path;
        },
    },
});
